import React from "react";
import { Button, Modal } from "react-bootstrap";
import CheckGreenIcon from "../../../../assets/img/check-green.png";
import { fetchStrapi, fetchStrapiPSHB } from "../../../../utils/fetch";

import "./informacion.scss";
export const InformacionComponent = ({ visible = false, onToggle }) => {
  const [contenido, setContenido] = React.useState(null);
  const [loader, setLoader] = React.useState(true);

  React.useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const { data } = await fetchStrapiPSHB(
        `ayudas?idEmpresa=2&codigo=reintegrosPS`,
        "GET"
      );
      setContenido(data[0]);
      setLoader(false);
    } catch (error) {
      setLoader(false);
    }
  };

  return (
    <Modal
      size={"xl"}
      aria-labelledby="contained-modal-title-vcenter"
      show={visible}
      centered
      onHide={onToggle}
    >
      <Modal.Header closeButton className="header-modal-pshb">
        <Modal.Title className="titulo-facturas">
          {contenido?.titulo}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="subtitulo-credencial">
          <span className="subtitulo">{contenido?.descripcionCorta}</span>
        </div>
        <div className="politica-proteccion-pshb" />
        {/* <div className='barra-politica-proteccion-pshb' /> */}

        {contenido?.multimedia?.url && (
          <div className="tutorial-credencial">
            <img
              className="tutorial-credencial-dos"
              src={contenido?.multimedia?.url}
              alt="..."
            ></img>
          </div>
        )}
        <div className="barra-politica-proteccion-pshb" />

        {contenido?.preguntas?.map((pregunta, index) => (
          <div>
            <div className="preguntas-credencial">
              <img className="i-25" src={CheckGreenIcon} alt="..."></img>
              <div className="question">{pregunta.descripcionCorta}</div>
            </div>
            {pregunta?.respuestas?.map((respuesta, index1) => (
              <div className="">
                <div className="answer-credencial">
                  {/* {respuesta.descripcion}{" "} */}
                  {respuesta.descripcion.split("\n").map((line, index) => (
                    <React.Fragment key={index}>
                      {line}
                      <br />
                    </React.Fragment>
                  ))}
                </div>
              </div>
            ))}
          </div>
        ))}
      </Modal.Body>
      {/* <Modal.Footer>                
                <Button className='btn2-color3-r' variant="primary" onClick={()=>onToggle()}>Cerrar</Button>
            </Modal.Footer> */}
    </Modal>
  );
};
